import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from '@ipc/ipc-components';
import {
  getDeleteContactRequestLoading,
  getXmlContactsData,
  getXmlContactsIsLoading,
} from '../redux/selectors/MrdContactsSelectors';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/list-table/components/ListTable';
import { getUserRole } from '../../../../common/user/redux/selectors/UserSelectors';
import XmlContactsColumns from './XmlContactsColumns';
import ConfirmationDialog from '../../../../common/list-table/helpers/confirmationDialog';
import { formatMessage } from '../../../../../locales/locales';
import {
  addNewContactRequestActionCreator,
  deleteContactRequestActionCreator,
  editContactRequestActionCreator,
} from '../redux/actions/ContactsActions';
import MrdContactsCreateDialog from '../create/component/MrdContactsCreateDialog';
import { IpcXmlContactsStyles } from '../component/IpcXmlContacts.styles';
import EditContactDialog from '../edit-contact/component/EditContactDialog';

function XmlContactsContainer(props) {
  const {
    isLoading,
    data,
    userRole,
    deleteContact,
    addContact,
    editContact,
  } = props;

  const [deleteVisible, updateDeleteVisibility] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [rowToEdit, setRowToEdit] = useState(null);
  const [editVisible, updateEditVisibility] = useState(false);
  const [showAddNewContactDialog, updateShowAddNewContactDialog] = useState(false);

  const [editDuplicateVisible, updateEditDuplicateVisibility] = useState(false);

  const handleDeleteDialogCancel = () => {
    updateDeleteVisibility(false);
  };

  const handleConfirmDelete = async () => {
    await deleteContact({
      contactGroup: 'DATA_SHARING',
      contactId: rowToDelete,
    });
    updateDeleteVisibility(false);
  };

  const onRowDelete = (row) => {
    setRowToDelete(row.id);
    updateDeleteVisibility(true);
  };
  const onRowEdit = (row) => {
    setRowToEdit(row);
    updateEditVisibility(true);
  };

  const openNewContactDialog = () => {
    updateShowAddNewContactDialog(true);
  };

  const closeNewContactDialog = () => {
    updateShowAddNewContactDialog(false);
  };
  const handleEditDuplicateDialogCancel = () => {
    updateEditDuplicateVisibility(false);
  };

  const confirmAddNewContact = async (requestData) => {
    if (requestData.isEmailDuplicate) {
      setRowToEdit({
        id: requestData.isEmailDuplicate,
        emailAddress: requestData.emailAddress,
      });
      updateEditDuplicateVisibility(true);
    } else {
      await addContact({
        ...requestData,
        contactGroup: 'DATA_SHARING',
      });
    }
  };
  const confirmEditContact = async (requestData) => {
    await editContact({
      ...requestData,
      contactGroup: 'DATA_SHARING',
    });
  };
  const handleConfirmDuplicateEdit = () => {
    updateEditDuplicateVisibility(false);
    updateShowAddNewContactDialog(false);
    updateEditVisibility(true);
  };

  const columns = XmlContactsColumns(data, userRole, onRowDelete, onRowEdit);

  return (
    <IpcXmlContactsStyles>
      <div className="mrd-contact-button-container">
        {
          userRole.includes('IPC_ADMIN') && (
            <Button
              onClick={openNewContactDialog}
              className="primary-button-false mrd-contact-button"
            >
              New contact
            </Button>
          )
        }
      </div>
      <ListTable
        listId={TableDefinitions.XML_CONTACTS.id}
        loading={isLoading}
        columns={columns}
        data={data}
      />
      <ConfirmationDialog
        isOpen={deleteVisible}
        submitButtonText="Yes"
        cancelButtonText="No"
        onClose={handleDeleteDialogCancel}
        onSubmit={handleConfirmDelete}
        confirmationTitle={formatMessage('en', 'contact.xml.delete.active.label')}
      />
      {editVisible && (
        <EditContactDialog
          isOpen={editVisible}
          closeDialog={() => { updateEditVisibility(false); }}
          handleCancel={() => { updateEditVisibility(false); }}
          confirmHandle={confirmEditContact}
          selectedContact={rowToEdit}
        />
      )}
      {showAddNewContactDialog && (
        <MrdContactsCreateDialog
          isOpen={showAddNewContactDialog}
          closeDialog={closeNewContactDialog}
          handleCancel={() => { updateShowAddNewContactDialog(false); }}
          addNewContact={confirmAddNewContact}
          selectedImpc={null}
        />
      )}
      <ConfirmationDialog
        isOpen={editDuplicateVisible}
        submitButtonText="Yes"
        cancelButtonText="No"
        onClose={handleEditDuplicateDialogCancel}
        onSubmit={handleConfirmDuplicateEdit}
        confirmationTitle={formatMessage('en', 'contact.edit.existing.ipc.label')}
      />
    </IpcXmlContactsStyles>
  );
}

function mapStateToProps(state) {
  return {
    data: getXmlContactsData(state),
    isLoading: getXmlContactsIsLoading(state),
    userRole: getUserRole(state),
    deleteContactRequestStatus: getDeleteContactRequestLoading(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteContact: deleteContactRequestActionCreator,
  addContact: addNewContactRequestActionCreator,
  editContact: editContactRequestActionCreator,
}, dispatch);

XmlContactsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userRole: PropTypes.string,
  deleteContact: PropTypes.func,
  addContact: PropTypes.func,
  editContact: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(XmlContactsContainer);
